import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type SurveyButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: 'primary' | 'choice';
  selected?: boolean;
};

export default function SurveyButton({
  children,
  className,
  variant = 'primary',
  selected = false,
  type = 'button',
  ...props
}: SurveyButtonProps) {
  return (
    <button
      type={type}
      aria-pressed={variant === 'choice' ? selected : undefined}
      className={clsx(
        'rounded-sm px-4 py-3 text-center text-[16px] font-bold uppercase tracking-wide transition active:scale-[0.99] sm:text-[18px]',
        variant === 'primary' &&
          'min-w-[7rem] bg-black text-white shadow-md hover:bg-neutral-900 disabled:opacity-50',
        variant === 'choice' &&
          (selected
            ? 'border-2 border-white bg-black text-white shadow-[0_0_0_1px_rgba(255,255,255,0.5),0_0_14px_rgba(255,255,255,0.35)] ring-2 ring-white/70'
            : 'border border-white/20 bg-black text-white shadow-md hover:bg-neutral-900'),
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
